<app-eea-output-project
  [selectedProject]="selectedProject"
  [isProjectOwnershipValid]="isProjectOwnershipValid"
/>
